import { useContentLocale } from '@/hooks/useContentLocale'
import { deleteProductById } from '@/service/v3/endpoints/products'
import { unref } from 'vue'
import { useI18n } from './useI18N'
import type { MaybeRef } from './usePolicyTypeSelection'
import { useToast } from './useToast'

export const useDeleteProduct = () => {
  const i18n = useI18n()
  const { doToast } = useToast()
  const { pickTextFromLocale } = useContentLocale('-')

  const deleteProduct = async (
    productId: MaybeRef<number>,
    productTitle: MaybeRef<Record<string, string>>
  ) => {
    try {
      await deleteProductById(unref(productId))
      const productTitleText =
        pickTextFromLocale(unref(productTitle))?.trim() || '-'
      doToast({
        text: i18n.t(
          'product.delete.PRODUCT_DELETE_SUCCESS_FEEDBACK_PRODUCT_TITLE',
          {
            productTitle: productTitleText,
          }
        ),
      })
      return true
    } catch (error) {
      doToast({ text: String(error), theme: 'error' })
      return false
    }
  }
  return { deleteProduct }
}
